export default __webpack_public_path__ + "static/best-grad-school-8df7ede361900d1e19e45e3f3184fdfd.svg";